
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8690_24657)"}},[_c('path',{attrs:{"d":"M7.5 4.455v1.772L10 3.864 7.5 1.5v1.773c-2.763 0-5 2.115-5 4.727 0 .928.288 1.787.775 2.517l.913-.862A3.352 3.352 0 013.75 8c0-1.959 1.678-3.545 3.75-3.545zm4.225 1.028l-.912.862c.278.494.437 1.055.437 1.655 0 1.959-1.678 3.546-3.75 3.546V9.773L5 12.136 7.5 14.5v-1.773c2.762 0 5-2.115 5-4.727a4.51 4.51 0 00-.775-2.517z","fill":"#161619"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8690_24657"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .5)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    